import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/c/:id',
      name: 'confirmation',
      component: () => import('@/views/ConfirmationPage.vue')
    },
    {
      path: '*',
      name: 'notFound',
      component: () => import('@/views/PageNotFound.vue')
    }
  ]
})

export default router
